import { render, staticRenderFns } from "./MyNextpay.vue?vue&type=template&id=2ec39a8c&scoped=true"
import script from "./MyNextpay.vue?vue&type=script&lang=js"
export * from "./MyNextpay.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style_hdsd.css?vue&type=style&index=0&id=2ec39a8c&prod&scoped=true&lang=css&external"
import style1 from "@/assets/css/bootstrap4.3.1.min.css?vue&type=style&index=1&id=2ec39a8c&prod&scoped=true&lang=css&external"
import style2 from "./MyNextpay.vue?vue&type=style&index=2&id=2ec39a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec39a8c",
  null
  
)

export default component.exports